import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'jsmLivechatInstruction'
	| 'jsmLivechatTitle'
	| 'summaryLabel'
	| 'descriptionLabel'
	| 'startChatButton'
	| 'jsmLivechatErrorTitle'
	| 'jsmLivechatErrorDescription'
	| 'additionalFieldsLabel';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		jsmLivechatInstruction: {
			id: 'conversation-assistant-message-actions.jsm-livechat.instruction',
			defaultMessage:
				'Review and edit the details below, then click {startChatButtonCopy} to connect with a live agent.',
			description:
				'Instruction text displayed in the JSM livechat action card within the AI conversation interface, providing guidance on the next steps. The startChatButtonCopy placeholder will be substituted with the text of the start chat button.',
		},
		jsmLivechatTitle: {
			id: 'conversation-assistant-message-actions.jsm-livechat.title',
			defaultMessage: 'Chat with live agent',
			description:
				'Title text displayed at the top of an action card in the AI conversation interface when the AI suggests connecting the user to a live agent.',
		},
		summaryLabel: {
			id: 'conversation-assistant-message-actions.jsm-livechat.summary-label',
			defaultMessage: 'Summary',
			description:
				'Label text displayed above or next to a summary input field in the JSM livechat form within the AI conversation interface.',
		},
		descriptionLabel: {
			id: 'conversation-assistant-message-actions.jsm-livechat.description-label',
			defaultMessage: 'Description',
			description:
				'Label text displayed above or next to a description input field in the JSM livechat form within the AI conversation interface.',
		},
		startChatButton: {
			id: 'conversation-assistant-message-actions.jsm-livechat.start-chat-button',
			defaultMessage: 'Start chat',
			description:
				'Button label displayed on the primary action button in the JSM livechat action card. When clicked, it initiates the live chat with an agent.',
		},
		jsmLivechatErrorTitle: {
			id: 'conversation-assistant-message-actions.jsm-livechat.error-title',
			defaultMessage: 'Error starting chat',
			description:
				'Title text displayed at the top of an error notification when the livechat initiation fails.',
		},
		jsmLivechatErrorDescription: {
			id: 'conversation-assistant-message-actions.jsm-livechat.error-description',
			defaultMessage: 'There was an error starting the live chat. Please try again.',
			description:
				'Error message text displayed when the livechat initiation fails, prompting the user to retry.',
		},
		additionalFieldsLabel: {
			id: 'conversation-assistant-message-actions.jsm-livechat.additional-fields-label',
			defaultMessage: 'Additional Fields:',
			description:
				'Label text displayed above a section containing additional custom fields in the JSM livechat form.',
		},
	});

export default message;
